export const path = "/validar-conversiones";
export const component = () => import("./index.jsx");
export const sidebar = {
  title: "VALIDAR CONVERSIONES",
  section: "ALUNA",
  group: "CSM",
  order: 4,
  roles: [
    "Authenticated",
    "aluna",
    "aluna-management",
  ],
};
